// Mind2Magic CRM — UI Module
// Extracted from index.html Step 7.
// Theme, Toast, Modal, Zoom, UI Font Scale.

import { store } from './store.js'

// ========== THEME ==========

function applyTheme(theme) {
    document.body.setAttribute('data-theme', theme);
    const icon = document.getElementById('themeIcon');
    if (!icon) return;
    if (theme === 'light') {
        icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>';
    } else {
        icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>';
    }
}

function toggleTheme() {
    let theme = store.currentTheme;
    theme = theme === 'dark' ? 'light' : 'dark';
    store.currentTheme = theme;
    sessionStorage.setItem('m2m_crm_theme', theme);
    applyTheme(theme);
}


// ========== TOAST ==========

function toast(msg, type = 'success', opts = {}) {
    const container = document.getElementById('toasts');
    const t = document.createElement('div');
    t.className = `toast ${type}`;
    if (opts.onClick) t.style.cursor = 'pointer';
    t.innerHTML = `<span>${msg}</span><button class="toast-close" onclick="event.stopPropagation();this.parentElement.style.opacity='0';setTimeout(()=>{this.parentElement.remove();updateToastClearAll();},200)">&times;</button>`;
    if (opts.onClick) {
        t.addEventListener('click', (e) => {
            if (e.target.classList.contains('toast-close')) return;
            opts.onClick();
            t.style.opacity = '0'; setTimeout(() => { t.remove(); updateToastClearAll(); }, 200);
        });
    }
    container.appendChild(t);
    t.style.transition = 'opacity 0.3s';
    if (!opts.persistent) {
        const timer = setTimeout(() => { t.style.opacity = '0'; setTimeout(() => { t.remove(); updateToastClearAll(); }, 300); }, 5000);
        t._timer = timer;
    }
    updateToastClearAll();
}

function updateToastClearAll() {
    const container = document.getElementById('toasts');
    const existing = container.querySelector('.toast-clear-all');
    if (existing) existing.remove();
    const toasts = container.querySelectorAll('.toast');
    if (toasts.length >= 3) {
        const btn = document.createElement('div');
        btn.className = 'toast-clear-all';
        btn.textContent = `Limpiar todo (${toasts.length})`;
        btn.onclick = clearAllToasts;
        container.appendChild(btn);
    }
}

function clearAllToasts() {
    const container = document.getElementById('toasts');
    container.querySelectorAll('.toast').forEach(t => {
        if (t._timer) clearTimeout(t._timer);
        t.style.opacity = '0';
        setTimeout(() => t.remove(), 200);
    });
    const btn = container.querySelector('.toast-clear-all');
    if (btn) setTimeout(() => btn.remove(), 250);
}


// ========== MODAL ==========

function openModal(id) {
    const el = document.getElementById(id)
    if (!el) return
    el.classList.add('active')
    // Scroll modal content to top
    const modal = el.querySelector('.modal')
    if (modal) modal.scrollTop = 0
}
function closeModal(id) { document.getElementById(id)?.classList.remove('active'); }


// ========== UI FONT SCALE ==========

const _UI_FONT_BASES = new WeakMap();
function applyUIFontScale(val) {
    const scale = parseFloat(val) || 1;
    const selectors = '.topbar .pipeline-title, .mode-label, .topbar .btn, .topbar .search-input, .filters-bar select, .filters-bar option, .filters-bar .btn, .date-range-indicator, .stat-label, .emp-stat-label, .col-header, .col-count, .calendario-header, .cal-day-header, .cal-legend';
    document.querySelectorAll(selectors).forEach(el => {
        if (!_UI_FONT_BASES.has(el)) {
            _UI_FONT_BASES.set(el, parseFloat(getComputedStyle(el).fontSize));
        }
        el.style.fontSize = (_UI_FONT_BASES.get(el) * scale) + 'px';
    });
}


// ========== ZOOM ==========

let currentNavZoom = 1;
let currentTopZoom = 1;
let currentLeadsZoom = 1;
let currentZoomScale = 1;
let _activeZoomEdit = null;
let _lastLeadsScale = 1;

const STAT_VAL_BASE_PX = 24;
const EMP_STAT_VAL_BASE_PX = 20;

function getActivePipeline() {
    const crmMode = store?.crmMode || 'turismo';
    if (crmMode === 'empresas') {
        return {
            pipeline: document.getElementById('empPipelineKanban'),
            wrapper: document.getElementById('empPipelineWrapper')
        };
    }
    return {
        pipeline: document.getElementById('pipeline'),
        wrapper: document.getElementById('pipelineWrapper')
    };
}

function setNavZoom(val) {
    const scale = parseFloat(val);
    currentNavZoom = scale;
    const sidebar = document.querySelector('.sidebar');
    if (sidebar) sidebar.style.zoom = scale;
    requestAnimationFrame(() => {
        const main = document.querySelector('.main');
        // Don't set margin-left on mobile/tablet — CSS handles it with margin-left: 0 !important
        if (main && window.innerWidth > 1024) main.style.marginLeft = (240 * scale) + 'px';
    });
    const navVal = document.getElementById('navZoomVal');
    if (navVal) navVal.textContent = `${scale.toFixed(2)}x`;
}

function setTopZoom(val) {
    const scale = parseFloat(val);
    currentTopZoom = scale;
    document.querySelectorAll('.stat-val').forEach(el => {
        el.style.fontSize = (STAT_VAL_BASE_PX * scale) + 'px';
    });
    document.querySelectorAll('.emp-stat-val').forEach(el => {
        el.style.fontSize = (EMP_STAT_VAL_BASE_PX * scale) + 'px';
    });
    document.getElementById('topZoomVal').textContent = `${scale.toFixed(2)}x`;
}

function setLeadsZoom(val) {
    const scale = parseFloat(val);
    currentLeadsZoom = scale;
    currentZoomScale = scale;

    const turPipeline = document.getElementById('pipeline');
    const empPipeline = document.getElementById('empPipelineKanban');
    if (turPipeline) turPipeline.style.transform = `scale(${scale})`;
    if (empPipeline) empPipeline.style.transform = `scale(${scale})`;

    document.querySelectorAll('.zoomable-content').forEach(el => {
        if (scale === 1) {
            el.style.zoom = '';
            el.style.width = '';
        } else {
            el.style.zoom = scale;
            el.style.width = (100 / scale) + '%';
        }
    });

    requestAnimationFrame(() => {
        _recalcPipelineHeight();
        _recalcViewScrollWraps();
        const { wrapper } = getActivePipeline();
        if (wrapper && _lastLeadsScale !== scale) {
            const ratio = scale / _lastLeadsScale;
            wrapper.scrollLeft = Math.max(0, wrapper.scrollLeft * ratio);
            _lastLeadsScale = scale;
        }
    });

    document.getElementById('leadsZoomVal').textContent = `${scale.toFixed(2)}x`;
}

function _recalcViewScrollWraps() {
    document.querySelectorAll('.view.active .view-scroll-wrap').forEach(wrap => {
        const top = wrap.getBoundingClientRect().top;
        const remaining = window.innerHeight - top - 4;
        if (remaining > 100) wrap.style.height = remaining + 'px';
    });
}

function _recalcPipelineHeight() {
    const { pipeline, wrapper } = getActivePipeline();
    if (pipeline && wrapper) {
        const wrapperTop = wrapper.getBoundingClientRect().top;
        const wrapperH = Math.round(window.innerHeight - wrapperTop - 4);
        if (wrapperH < 100) return;
        wrapper.style.height = wrapperH + 'px';
        const innerH = Math.round(wrapperH / currentLeadsZoom);
        pipeline.style.height = innerH + 'px';
        const colMax = Math.round(innerH - 45);
        const cols = pipeline.querySelectorAll('.column');
        for (let i = 0; i < cols.length; i++) cols[i].style.height = innerH + 'px';
        const cardContainers = pipeline.querySelectorAll('.col-cards');
        for (let i = 0; i < cardContainers.length; i++) cardContainers[i].style.maxHeight = colMax + 'px';
    }
}

// Zoom slider setup
document.addEventListener('DOMContentLoaded', () => {
    const navSlider = document.getElementById('navZoomSlider');
    const topSlider = document.getElementById('topZoomSlider');
    const leadsSlider = document.getElementById('leadsZoomSlider');
    if (navSlider) navSlider.addEventListener('input', (e) => setNavZoom(e.target.value));
    if (topSlider) topSlider.addEventListener('input', (e) => setTopZoom(e.target.value));
    if (leadsSlider) leadsSlider.addEventListener('input', (e) => setLeadsZoom(e.target.value));
});

// Recalculate on window resize
window.addEventListener('resize', () => {
    _recalcPipelineHeight();
    _recalcViewScrollWraps();
});

const _zoomConfigs = {
    nav:   { valId: 'navZoomVal',   sliderId: 'navZoomSlider',   fn: setNavZoom,   min: 0.7, max: 1.3 },
    top:   { valId: 'topZoomVal',   sliderId: 'topZoomSlider',   fn: setTopZoom,   min: 0.5, max: 2.5 },
    leads: { valId: 'leadsZoomVal', sliderId: 'leadsZoomSlider', fn: setLeadsZoom, min: 0.7, max: 2.5 }
};

function resetZoom(which) {
    if (which === 'all') {
        ['nav', 'top', 'leads'].forEach(k => resetZoom(k));
        return;
    }
    const cfg = _zoomConfigs[which];
    if (!cfg) return;
    const slider = document.getElementById(cfg.sliderId);
    if (slider) slider.value = 1;
    cfg.fn(1);
}

function editZoomValue(which) {
    _activeZoomEdit = which;
    const cfg = _zoomConfigs[which];
    const span = document.getElementById(cfg.valId);
    const input = document.getElementById('zoomInput');
    input.min = cfg.min;
    input.max = cfg.max;

    span.style.display = 'none';
    span.parentElement.appendChild(input);
    input.style.display = 'inline';
    input.value = parseFloat(span.textContent) || 1;
    input.focus();
    input.select();
}

function applyZoomInput() {
    const which = _activeZoomEdit || 'leads';
    const cfg = _zoomConfigs[which];
    const span = document.getElementById(cfg.valId);
    const input = document.getElementById('zoomInput');
    const slider = document.getElementById(cfg.sliderId);

    let val = parseFloat(input.value) || 1;
    val = Math.max(cfg.min, Math.min(cfg.max, val));
    val = Math.round(val * 100) / 100;

    if (slider) slider.value = val;
    cfg.fn(val);

    input.style.display = 'none';
    span.style.display = 'inline';
    _activeZoomEdit = null;
}

function cancelZoomInput() {
    const which = _activeZoomEdit || 'leads';
    const cfg = _zoomConfigs[which];
    const span = document.getElementById(cfg.valId);
    const input = document.getElementById('zoomInput');
    input.style.display = 'none';
    span.style.display = 'inline';
    _activeZoomEdit = null;
}


// ========== MOBILE SIDEBAR & NAV ==========

function toggleSidebar() {
    const sidebar = document.querySelector('.sidebar');
    const backdrop = document.getElementById('sidebarBackdrop');
    if (!sidebar) return;
    const isOpen = sidebar.classList.toggle('open');
    if (backdrop) backdrop.classList.toggle('open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
}

function closeSidebarIfMobile() {
    if (window.innerWidth > 768) return; // Only close on phone; iPad has permanent sidebar
    const sidebar = document.querySelector('.sidebar');
    const backdrop = document.getElementById('sidebarBackdrop');
    if (sidebar) sidebar.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    document.body.style.overflow = '';
}

// Bottom tab bar navigation
function mobileNav(tab) {
    closeSidebarIfMobile();
    // Use window.showView — it's registered by orchestrator.js
    if (window.showView) window.showView(tab);
    _syncMobileTab(tab);
}

// Sync the active tab indicator with the current view
function _syncMobileTab(viewName) {
    if (window.innerWidth > 768) return; // tab bar is phone-only
    const tabBar = document.getElementById('mobileTabBar');
    if (!tabBar) return;
    const tabMap = { pipeline: 'pipeline', empPipeline: 'pipeline', calendario: 'calendario', dashboard: 'dashboard', tareas: 'tareas' };
    const activeTab = tabMap[viewName] || 'more';
    tabBar.querySelectorAll('.tab-item').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.tab === activeTab);
    });
}

// Patch showView to also sync mobile tab bar when navigating via sidebar
document.addEventListener('DOMContentLoaded', () => {
    const _checkAndPatch = () => {
        if (window.showView && !window.showView._mobilePatched) {
            const orig = window.showView;
            window.showView = function(v) {
                orig(v);
                _syncMobileTab(v);
            };
            window.showView._mobilePatched = true;
        }
    };
    _checkAndPatch();
    // Retry after a tick in case orchestrator hasn't registered yet
    setTimeout(_checkAndPatch, 100);
});

// Auto-close sidebar when nav item is tapped on mobile
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nav-item').forEach(item => {
        item.addEventListener('click', closeSidebarIfMobile);
    });
});

// ========== MOBILE FILTERS TOGGLE ==========

function toggleMobileFilters() {
    const bar = document.querySelector('#pipelineView .filters-bar') ||
                document.querySelector('.filters-bar');
    if (bar) bar.classList.toggle('filters-open');
}

function updateMobileFiltersBadge() {
    const badge = document.getElementById('mobileFiltersBadge');
    if (!badge) return;
    let count = 0;
    const checks = [
        { id: 'filterTipo', empty: '' },
        { id: 'filterResponsable', empty: '' },
        { id: 'filterMes', empty: '' },
        { id: 'filterYear', empty: '' },
        { id: 'filterEtapa', empty: '' },
        { id: 'filterPeriodo', empty: '' },
    ];
    checks.forEach(c => {
        const el = document.getElementById(c.id);
        if (el && el.value !== c.empty) count++;
    });
    if (document.getElementById('includeHistorico')?.checked) count++;
    if (document.getElementById('modoCompletoCheck')?.checked) count++;
    badge.textContent = count;
    badge.classList.toggle('has-filters', count > 0);
}

// Register on window for inline module and HTML handlers
Object.assign(window, {
    applyTheme, toggleTheme,
    toast, updateToastClearAll, clearAllToasts,
    openModal, closeModal,
    applyUIFontScale,
    getActivePipeline, setNavZoom, setTopZoom, setLeadsZoom,
    resetZoom, editZoomValue, applyZoomInput, cancelZoomInput,
    _recalcPipelineHeight, _recalcViewScrollWraps,
    toggleSidebar, closeSidebarIfMobile, mobileNav,
    toggleMobileFilters, updateMobileFiltersBadge,
});

// Expose zoom state for inline module reads via window getter
Object.defineProperty(window, '_currentLeadsZoom', { get() { return currentLeadsZoom; }, configurable: true });
Object.defineProperty(window, '_currentZoomScale', { get() { return currentZoomScale; }, configurable: true });
